module.exports = __webpack_public_path__ + "assets/daf715542a043b19f1007ed8a245f0fd.mp3";